module.exports = __webpack_public_path__ + "static/img/healer2.e531898.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/healer2.png
// module id = 39Vm
// module chunks = 0